module.exports = __webpack_public_path__ + "img/laravel.c42b245f.png";